import React from 'react';
import PropTypes from 'prop-types';

const ListeJoueurs = ({ children, isOpen, onToggle }) => {
    return (
        <div className="flex flex-col gap-4 p-4 md:p-6 mx-4 my-4 md:my-10 bg-[#272727] rounded-lg shadow-lg min-h-0 text-center md:w-full">
            <div
                className="flex flex-row justify-between items-center cursor-pointer md:cursor-default"
                onClick={onToggle}
            >
                <h1 className="text-white font-semibold text-2xl mb-2 font-poppins flex-1">T1 2026 ROSTER</h1>
                <span className="md:hidden text-gray-400 text-lg select-none">{isOpen ? '▲' : '▼'}</span>
            </div>
            <div className={`flex flex-col gap-4 min-h-0 ${isOpen ? '' : 'hidden md:flex'}`}>
                {children}
            </div>
        </div>
    )
}

ListeJoueurs.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
}

ListeJoueurs.defaultProps = {
    children: null,
    isOpen: true,
    onToggle: () => {},
};

export default ListeJoueurs;